import axios from "axios";

import requestInterceptor, {
  recommendedrequestInterceptorS1,
  recommendedrequestInterceptorS2,
} from "./helpers/request-interceptors";

import {
  handleErrorResponse,
  handleSuccessResponse,
} from "./helpers/response-interceptors";

const SERVER_URL_CPP = process.env.REACT_APP_SERVER_URL_CPP;
const SERVER_URL_NODE = process.env.REACT_APP_SERVER_URL_NODE;

//must
const service = axios.create({
  baseURL: SERVER_URL_NODE,
});

// interceptor to get the access token if expired
service.interceptors.request.use((config) => requestInterceptor(config));

// interceptor to handle the response
service.interceptors.response.use(handleSuccessResponse, handleErrorResponse);

// interceptor to get access token for recommended routes ( login not required - public routes )
service.interceptors.request.use((config) =>
  recommendedrequestInterceptorS1(config)
);

const service2 = axios.create({
  baseURL: SERVER_URL_CPP,
});

service2.interceptors.request.use((config) =>
  recommendedrequestInterceptorS2(config)
);

// interceptor to handle the response
service2.interceptors.response.use(handleSuccessResponse, handleErrorResponse);

export { service, service2 };
